import React from 'react';
import { PRIMARY } from '../../../../theme';
export var Schedule = function Schedule(props) {
  var fillColor = props.color || PRIMARY;
  return /*#__PURE__*/React.createElement("svg", {
    width: "21",
    height: "19",
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0.5",
    y: "1.89648",
    width: "18.9456",
    height: "14.8624",
    rx: "1.5",
    stroke: fillColor,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    y1: "6.29926",
    x2: "19.5629",
    y2: "6.29926",
    stroke: fillColor
  }), /*#__PURE__*/React.createElement("line", {
    x1: "5.11609",
    y1: "0.500061",
    x2: "5.11609",
    y2: "3.85913",
    stroke: fillColor,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "15.4467",
    y1: "0.5",
    x2: "15.4467",
    y2: "3.85907",
    stroke: fillColor,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 14.1626C20.5 16.5694 18.5979 18.5 16.2764 18.5C13.955 18.5 12.0529 16.5694 12.0529 14.1626C12.0529 11.7558 13.955 9.82513 16.2764 9.82513C18.5979 9.82513 20.5 11.7558 20.5 14.1626Z",
    fill: "white",
    stroke: fillColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2764 11.7254L16.2764 14.1625L18.3162 14.1625",
    stroke: fillColor,
    strokeWidth: "0.8",
    strokeLinecap: "round",
    fill: "none"
  }));
};